module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/Onekey.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2FOnekey.png
// module id = aNrW
// module chunks = 93